import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const ChainIcon: React.FC<any> = ({ className, width = 16, height = 16, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4Z" fill="#000000" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12.7071 4.79289C13.0976 5.18342 13.0976 5.81658 12.7071 6.20711L7.70711 11.2071C7.31658 11.5976 6.68342 11.5976 6.29289 11.2071L3.29289 8.20711C2.90237 7.81658 2.90237 7.18342 3.29289 6.79289C3.68342 6.40237 4.31658 6.40237 4.70711 6.79289L7 9.08579L11.2929 4.79289C11.6834 4.40237 12.3166 4.40237 12.7071 4.79289Z" fill="white" />
    </svg>
  </span>
);

export default ChainIcon;
